import { useMemo } from 'react'
import useBusiness from './api-hooks/useBusiness'
import useSelectedLocation from './api-selected-hooks/useSelectedLocation'

const useTimezone = () => {
  const { business } = useBusiness()
  const { selectedLocation } = useSelectedLocation()

  const timezone = useMemo(() => {
    return selectedLocation?.timezone || business?.timezone
  }, [selectedLocation, business])

  return timezone?.replace(/\\/, '')
}

export default useTimezone
